// frontend/src/components/ProtectedRoute.tsx
import { Navigate, useLocation } from 'react-router-dom';

import { isAuthenticated } from '@/lib/auth';

export function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const location = useLocation();
  if (!isAuthenticated()) {
    // The query rides along: the AI-app consent page (/connect/authorize) carries
    // its whole OAuth request in it, and losing it would strand the sign-in.
    return <Navigate to="/login" replace state={{ from: location.pathname + location.search }} />;
  }
  return <>{children}</>;
}
